import axios from 'axios';
const api = process.env.REACT_APP_SERVER_ENDPOINT;

export default {
	/**
	 * Check if user has app + strava cookies in the app
	 *
	 * URL: /profile/
	 * Method: GET
	 * URL Params: Required
	 * Success Response: 200 Content
	 * 400 Bad Request - invalid company code Content:
	 *
	 * @returns
	 */
	checkIsLoggedIn() {
		return axios.get(`${api}/profile/`, {
			withCredentials: true,
		});
	},

	/**
	 * Find Profile by auth cookie.
	 *
	 * URL: /profile/{code}/{referral} or /profile/{code} or /profile/
	 * Method: GET
	 * URL Params: Required: code = [string] company code, e.g.: WITS18
	 * Optional: none
	 * Success Response: 200 Content
	 * Error Response:
	 * 401 Unauthorized - list of authentication servers
	 * 400 Bad Request - invalid company code Content:
	 * 400 Bad Request - invalid company code Content:
	 *
	 * @param {*} companyID
	 * @param {*} referralEmail
	 * @returns
	 */
	findProfileByCookie(companyID, referralCode) {
		return axios.get(`${api}/profile/${companyID}/${referralCode}`, {
			withCredentials: true,
		});
	},

	/**
	 * Logs the user out.
	 *
	 * URL: /auth/logout
	 * Method: GET
	 * Optional: none
	 * Success Response: 200 Content
	 * Error Response:
	 *
	 * @param {*} companyID
	 * @param {*} referralEmail
	 * @returns
	 */
	doTheLogOut() {
		return axios.get(`${api}/auth/logout`, {
			withCredentials: true,
		});
	},

	/**
	 * Automatically sets a JSESSIONID cookie on the client
	 * WARNING: THis is temporary!
	 *
	 * @returns
	 */
	userAlreadyHasAnAccount() {
		return axios.get(`${api}/invitation/my`, {
			withCredentials: true,
		});
	},
};



// WEBPACK FOOTER //
// ./src/data/services/authentication-service.js